// eslint-disable-next-line @alto/no-pocky-import
import { Button, FlexRow, H4, Text, spacing } from '@alto/pocky';
import React, { PureComponent } from 'react';
import styled from 'styled-components';

const StyledButton = styled(Button)`
  display: inline;
`;

const StyledFlexRow = styled(FlexRow)<{ inline?: boolean }>`
  ${({ inline }) =>
    inline &&
    `
    flex-direction: row-reverse;
  `}
`;

type Props = {
  readonly onAddInsurance: () => void;
  readonly inlineButton?: boolean;
};

export default class CashPayInsurance extends PureComponent<Props> {
  render() {
    const { onAddInsurance, inlineButton } = this.props;
    return (
      <FlexRow spacing={spacing.lgSpacing}>
        <FlexRow spacing={spacing.xsSpacing}>
          <H4>You’re paying out of pocket</H4>
          <Text>
            Since you’ve elected to not use insurance, we’ll show you the out of pocket prices for your medications. We
            still apply any available coupons or discounts to get you the best price possible.
          </Text>
        </FlexRow>
        <FlexRow spacing={spacing.xsSpacing}>
          <H4>Did your coverage change?</H4>
          <Text>Provide your new insurance details and moving forward we’ll bill medications to your insurance.</Text>
        </FlexRow>
        <StyledFlexRow inline={inlineButton}>
          <StyledButton onClick={onAddInsurance}>Add Insurance</StyledButton>
        </StyledFlexRow>
      </FlexRow>
    );
  }
}
